import { createFileRoute } from "@tanstack/react-router";
import { NetworkCallout } from "@/components/site/BrandNetwork";
import { ProductPage } from "@/components/site/ProductPage";
import { FixFlipCalculator } from "@/components/site/FixFlipCalculator";
import { FixFlipExtras } from "@/components/site/FixFlipExtras";
import { getProduct } from "@/data/products";
import { getProductHero } from "@/data/productHeroes";
import { buildHead } from "@/lib/seo-head";

const SLUG = "fix-and-flip-loans";
const PRODUCT = getProduct(SLUG)!;
const HERO = getProductHero(SLUG);
const URL = `/${SLUG}`;

const KEYWORDS = [
  "fix and flip loan",
  "hard money flip loan",
  "rehab loan for investors",
  "fix and flip financing",
  "100% rehab funding loan",
  "flip loan rates",
  "house flipping loan",
  "fix and flip bridge loan",
  "flip loan LLC",
  "renovation loan for investors",
  "purchase and rehab loan",
  "flip loan draw schedule",
].join(", ");

export const Route = createFileRoute("/fix-and-flip-loans/")({
  head: () =>
    buildHead({
      title: "Fix & Flip Loans: Purchase + 100% Rehab Funding",
      description:
        "12-month interest-only fix and flip loans for buy, renovate, and resell. Up to 90% of purchase and 100% of rehab, funded on 2-week draws.",
      url: URL,
      keywords: KEYWORDS,
      image: HERO?.src,
      imageAlt: HERO?.alt,
      breadcrumbs: [
        { name: "Home", url: "/" },
        { name: PRODUCT.shortName, url: URL },
      ],
      service: { name: PRODUCT.name },
      faqs: PRODUCT.faq.map((f) => ({ q: f.q, a: f.a })),
    }),

  component: () => (
    <ProductPage
      product={PRODUCT}
      hideBaseTools
      extraTools={
        <>
          <FixFlipCalculator />
          <FixFlipExtras />
          <NetworkCallout
            title="Need working capital for your flipping business?"
            body="Fix and flip loans fund the property. For business lines of credit, equipment or general working capital for your LLC, see our business lending site."
            sites={["Simply Approved Business Loans"]}
          />
        </>
      }
    />
  ),
});
